import { AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS } from '@src/utils/aiAlerts/mapping';
import { atom } from 'jotai';
import update from 'immutability-helper';

type Payload = {
  key: string;
  value: any;
};

const selectedProductAtom = atom(
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS.find((it) => it.value === (window.conviva.module || 'EI'))
    ?.value,
);

const drawerMetricsAtom = atom([]);

const fullSensitivityConfigAtom = atom([]);

const updateSensitivityDataObjAtom = atom(null, (get, set, payload: Payload) => {
  const data: any = get(fullSensitivityConfigAtom);
  const updatedData = update(data, { $merge: { [payload.key]: payload.value } });
  set(fullSensitivityConfigAtom, updatedData);
});

export {
  updateSensitivityDataObjAtom,
  selectedProductAtom,
  fullSensitivityConfigAtom,
  drawerMetricsAtom,
};
